export default {
    describeSelf: 'عن نفسي',
    describeOthers: 'ماذا اريد من شريكي',
    startChat: 'تواصل',
    likeRequest: '%{username} رسالة اعجاب',
    likeRequested: ' قبول الاعجاب. انتظار %{username} للموافقة',
    likeAccepted: '%{username} وافق على الاعجاب',
    accept: 'موافقة',
    reject: 'رفض',
    likeAccept: `موافق %{username} على الاعجاب`,
    likeReject: `ارفض %{username} الاعجاب`,
    whatsapp: 'واتساب',
    email: 'ايميل',
    facebook: 'فايسبوك',
    instagram: 'انستغرام',
    subscribeForDetails: 'اشتراك للمزيد من التفاصيل',
    userBanned: 'هذا المشترك ممنوع',
    lastOnline: 'أخر ظهور:'
}
